// extracted by mini-css-extract-plugin
export default {"text":"CookiePolicyReminderBanner-module__text-Sab5","banner":"CookiePolicyReminderBanner-module__banner-NVHo","srOnly":"CookiePolicyReminderBanner-module__srOnly-fLXV"};